<template>
  <div class="pricing-cell">
    <div v-if="pricingState.status === 'idle'" class="text-muted">
      <small>{{ $t("bulk_buy.pricing_idle") }}</small>
    </div>

    <LoadingIndicatorComponent
      v-else-if="pricingState.status === 'loading'"
      inline
      class="small"
      :message="pricingState.message"
    />

    <div
      v-else-if="pricingState.status === 'success'"
      class="text-success fw-bold"
    >
      €{{ (pricingState.price || 0).toFixed(2) }}
      <span
        v-if="pricingState.price_date"
        class="d-block text-muted small fw-normal"
      >
        {{
          $t("bulk_buy.market_levels_as_of", {
            date: marketDataDateLabel(pricingState.price_date),
          })
        }}
      </span>
    </div>

    <div
      v-else-if="pricingState.status === 'agent_reach_out'"
      class="text-warning"
    >
      <FontAwesomeIcon icon="exclamation-triangle" class="me-1" />
      <small>{{ $t("bulk_buy.rfq_notice") }}</small>
    </div>

    <div v-else-if="pricingState.status === 'error'" class="text-danger">
      <FontAwesomeIcon icon="times-circle" class="me-1" />
      <small>{{ pricingState.message }}</small>
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingIndicatorComponent from "@/components/common/LoadingIndicatorComponent.vue";
import type { PricingState } from "./bulkBuyTypes";
import { marketDataDateLabel } from "./bulkBuyTypes";

defineProps<{
  pricingState: PricingState;
}>();
</script>

<style scoped>
.pricing-cell {
  min-height: 2rem;
  display: flex;
  align-items: center;
}
</style>
